import { api } from '../lib/api';

export interface BlendContainerOption {
  id: number;
  kind: 'HONEY' | 'POLLEN';
  containerCode: string;
  siteId: number;
  siteName: string;
  productId: number;
  productName: string;
  waterPercent: number | null;
  nectarItemId: number | null;
  nectarLabel: string | null;
  statusLabel: string | null;
  remainingKg: number;
}

export interface BlendingMeta {
  containers: BlendContainerOption[];
  products: Array<{
    id: number;
    name: string;
    kind: string;
    categoryLabel: string | null;
  }>;
  sites: Array<{ id: number; name: string }>;
  honeyStatuses: Array<{ id: number; label: string }>;
  pollenStatuses: Array<{ id: number; label: string }>;
}

export interface BlendListRow {
  id: number;
  blendDate: string;
  kind: 'HONEY' | 'POLLEN';
  status: 'DRAFT' | 'POSTED';
  notes: string | null;
  totalKg: number;
  outputBatchCode: string | null;
  siteId: number;
  siteName: string;
  productId: number | null;
  outputProductName: string | null;
  outputContainerId: number | null;
  outputContainerCode: string | null;
  inputCount: number;
}

export interface BlendDetails {
  id: number;
  blendDate: string;
  kind: 'HONEY' | 'POLLEN';
  status: 'DRAFT' | 'POSTED';
  notes: string | null;
  totalKg: number;
  outputStatusItemId: number | null;
  outputContainerId: number | null;
  outputBatchCode: string | null;
  consumeTxId: number | null;
  produceTxId: number | null;
  siteId: number;
  siteName: string;
  inputs: Array<{
    id: number;
    containerId: number;
    productId: number;
    inputBatchCodeSnapshot: string | null;
    kg: number;
    containerCode: string;
    productName: string;
    siteId: number;
    siteName: string;
    waterPercent: number | null;
    nectarItemId: number | null;
    nectarLabel: string | null;
  }>;
  outputs: Array<{
    id: number;
    productId: number;
    outputContainerId: number | null;
    kg: number;
    outputBatchCode: string | null;
    productName: string;
    outputContainerCode: string | null;
    outputWaterPercent: number | null;
    outputNectarItemId: number | null;
    outputNectarLabel: string | null;
    outputStatusLabel: string | null;
  }>;
}

export const blendingApi = {
  meta: () => api.get<BlendingMeta>('/blending/meta'),
  list: (year: number) => api.get<{ blends: BlendListRow[] }>(`/blending?year=${year}`),
  get: (id: number) => api.get<BlendDetails>(`/blending/${id}`),
  create: (payload: {
    blendDate: string;
    kind: 'HONEY' | 'POLLEN';
    siteId: number;
    outputProductId: number;
    outputStatusItemId?: number | null;
    notes?: string;
    inputs: Array<{
      containerId: number;
      kg: number;
    }>;
  }) => api.post<{ id: number }>('/blending', payload),
  post: (id: number, payload?: { outputStatusItemId?: number | null }) =>
    api.post<{ ok: boolean; outputContainerId: number; outputBatchCode: string }>(
      `/blending/${id}/post`,
      payload ?? {}
    ),
};
